<div class="pdp-description-container">
  <div class="overview-benefits">
    <div class="hide-content" #content>
      <div>
        <section *ngIf="hasOverviewSection">
          <h4 data-cy="overview-product-description-text">
            {{
              'i18n.productDetail.productDetailDescription.overview' | translate
            }}
          </h4>
          <p *ngIf="product?.detail?.additionalDescription">
            <span data-cy="addl-product-description-text">
              {{ product?.detail?.additionalDescription }}
            </span>
          </p>
          <ul>
            <li
              [attr.data-cy]="
                'product-detail-country-of-origin-grown-harvested-' +
                product?.productNumber +
                '-list'
              "
              *ngIf="product?.detail?.countryOfOriginGrownHarvested"
            >
              <span
                [attr.data-cy]="
                  'product-detail-country-of-origin-grown-harvested-' +
                  product?.productNumber +
                  '-text'
                "
                [id]="'pdp-grown-harvested-' + product?.productNumber"
              >
                {{
                  'i18n.productDetail.productDetailDescription.grownHarvested'
                    | translate
                      : {
                          value: product?.detail?.countryOfOriginGrownHarvested
                        }
                }}</span
              >
            </li>
            <li
              [attr.data-cy]="
                'product-detail-country-of-origin-processed-' +
                product?.productNumber +
                '-list'
              "
              *ngIf="product?.detail?.countryOfOriginProcessed"
            >
              <span
                [attr.data-cy]="
                  'product-detail-country-of-origin-processed-' +
                  product?.productNumber +
                  '-text'
                "
                [id]="'pdp-processed-' + product?.productNumber"
              >
                {{
                  'i18n.productDetail.productDetailDescription.countryOfOriginProcessed'
                    | translate
                      : { value: product?.detail?.countryOfOriginProcessed }
                }}
              </span>
            </li>
          </ul>
        </section>
        <div
          class="features-benefits-section"
          *ngIf="
            product?.detail?.productAttributes || product?.detail?.benefits
          "
        >
          <ng-container *ngTemplateOutlet="FeatureXBenefits"></ng-container>
        </div>
      </div>
    </div>
    <div
      [attr.data-cy]="
        'product-detail-country-of-origin-processed-' +
        product?.productNumber +
        '-text'
      "
      *ngIf="product?.detail?.productAttributes || product?.detail?.benefits"
    >
      <div class="view-btn" #moreBtn style="display: none">
        <span href="#" (click)="viewMore()" data-cy="view-more-button">
          {{ 'i18n.common.viewMore' | translate }}
          <ion-icon
            name="chevron-down-outline"
            data-cy="view-more-button-icon"
          ></ion-icon>
        </span>
      </div>
      <div class="view-btn" #lessBtn style="display: none">
        <span href="#" (click)="viewLess()" data-cy="view-less-button">
          {{
            'i18n.productDetail.productDetailDescription.viewLess' | translate
          }}
          <ion-icon
            name="chevron-up-outline"
            data-cy="view-less-button-icon"
          ></ion-icon>
        </span>
      </div>
    </div>
  </div>

  <div class="portions-features">
    <div
      class="portions-dimensions-section"
      *ngIf="portions.length > 0 || boxDimensions.length > 0"
      #portionsBox
    >
      <ng-container *ngTemplateOutlet="PortionsXDimensions"></ng-container>
    </div>
  </div>
</div>
<ng-template #FeatureXBenefits>
  <section class="has-features" *ngIf="!!product?.detail?.productAttributes">
    <h4
      [attr.data-cy]="
        'product-detail-description-features-' +
        product?.productNumber +
        '-text'
      "
    >
      {{ 'i18n.productDetail.productDetailDescription.features' | translate }}
    </h4>
    <ul class="disc-list" *ngIf="product?.detail?.productAttributes">
      <li
        [attr.data-cy]="
          'product-detail-description-features-' +
          product?.productNumber +
          '-list'
        "
        *ngFor="let item of features"
      >
        {{ item }}
      </li>
    </ul>
  </section>

  <section *ngIf="!!product?.detail?.benefits" class="has-benefits">
    <h4
      [attr.data-cy]="
        'product-detail-description-benefits' + product?.productNumber + '-text'
      "
    >
      {{ 'i18n.productDetail.productDetailDescription.benefits' | translate }}
    </h4>
    <ul class="disc-list" *ngIf="product?.detail?.benefits">
      <li
        *ngFor="let item of benefits"
        [attr.data-cy]="
          'product-detail-description-benefits-' +
          product?.productNumber +
          '-list'
        "
      >
        {{ item }}
      </li>
    </ul>
  </section>
</ng-template>
<ng-template #PortionsXDimensions>
  <section *ngIf="!!portions.length">
    <h4
      [attr.data-cy]="
        'product-detail-description-portions-' +
        product?.productNumber +
        '-text'
      "
    >
      {{ 'i18n.productDetail.productDetailDescription.portions' | translate }}
    </h4>
    <article class="portions-subsection">
      <ul>
        <ng-container *ngFor="let portion of portions">
          <li
            *ngIf="portion.value && portion.visible !== false"
            [attr.data-cy]="
              'product-detail-description-portions-' +
              product?.productNumber +
              '-list'
            "
            [id]="
              'pdp-portions-' + portion.keyLabel + '-' + product?.productNumber
            "
          >
            <label
              [attr.data-cy]="
                'product-detail-description-portions-' +
                portion?.keyLabel +
                '-text'
              "
            >
              {{ portion.keyLabel | translate }}:
            </label>
            {{ portion.value }}
          </li>
        </ng-container>
      </ul>
      <ion-img
        id="product-portions-img"
        src="assets/images/product-portion.svg"
        [attr.data-cy]="
          'product-detail-description-portions-' +
          product?.productNumber +
          '-image'
        "
      ></ion-img>
    </article>
  </section>
  <section *ngIf="!!boxDimensions.length">
    <h4
      [attr.data-cy]="
        'product-detail-description-box-dimensions-' +
        product?.productNumber +
        '-text'
      "
    >
      {{
        'i18n.productDetail.productDetailDescription.boxDimensions' | translate
      }}
    </h4>
    <article class="box-subsection">
      <ul>
        <ng-container *ngFor="let dimension of boxDimensions">
          <li
            *ngIf="dimension.visible"
            [attr.data-cy]="
              'product-detail-description-box-dimensions-' +
              product?.productNumber +
              '-list'
            "
            [id]="
              'pdp-box-dimensions-' +
              dimension.keyLabel +
              '-' +
              product?.productNumber
            "
          >
            <label
              [attr.data-cy]="
                'product-detail-description-box-dimensions-' +
                dimension.keyLabel +
                '-text'
              "
            >
              {{ dimension.keyLabel | translate }}:&nbsp;</label
            >{{ dimension.value }}
          </li>
        </ng-container>
      </ul>
      <ion-img
        id="box-dimensions-img"
        src="assets/images/box-dimension.svg"
        [attr.data-cy]="
          'product-detail-description-box-dimensions-' +
          product?.productNumber +
          '-image'
        "
      ></ion-img>
    </article>
  </section>
</ng-template>
